import TabCoaches from "@/views/App/Dashboard/PracticeManager/TabCoaches.vue";
import TabUnitsDoneByLocation from "@/views/App/Dashboard/PracticeManager/TabUnitsDoneByLocation.vue";
import TabInfo from "@/views/App/Dashboard/PracticeManager/TabInfo.vue";
import TabPotentialUnits from "@/views/App/Dashboard/PracticeManager/TabPotentialUnits.vue";
import UnsignedUnitsLocation from "@/views/App/Dashboard/PracticeManager/UnsignedUnitsLocation.vue";

const routesDashboardPracticeManager = [
    {
        path: 'info',
        name: 'dashboardPracticeManagerInfo',
        component: TabInfo
    },
    {
        path: 'potential-units',
        name: 'dashboardPracticeManagerUnitsPotentialUnits',
        component: TabPotentialUnits
    },
    {
        path: 'unit-done-by-location',
        name: 'dashboardPracticeManagerUnitsDoneByLocation',
        component: TabUnitsDoneByLocation
    },
    {
        path: 'unsigned-units-location/:locationId',
        name: 'dashboardPracticeManagerUnsignedUnitsLocation',
        component: UnsignedUnitsLocation
    }
  ];

export default routesDashboardPracticeManager;